<template>
  <div class="quote-price-setting">
    <div class="top">
      <div class="flex-item">
        <b>询单报价设置</b>
        <span class="tip">设置完成后，填写报价单会自动默认为设置字段，可编辑修改。</span>
      </div>
      <div class="flex-item">
        <template v-if="!isEdit">
          <el-button @click="handleEdit" type="primary">设置</el-button>
        </template>
        <template v-else>
          <el-button plain @click="handleClose">取消</el-button>
          <el-button @click="handleSave" type="primary">保存</el-button>
        </template>
      </div>
    </div>
    <div class="content">
      <template v-if="!isEdit">
        <el-descriptions :colon="false" :column="2" size="medium">
          <el-descriptions-item label="询单接单人">
            {{ info.inquirePriceTaskOrderUserName || '--' }}
            <div class="employee-type">固定员工</div>
          </el-descriptions-item>
          <el-descriptions-item label="税率">{{ info.quoteTaxRate !== null && info.quoteTaxRate !== undefined ? `${info.quoteTaxRate}%` : '--' }}</el-descriptions-item>
          <el-descriptions-item label="付款方式" :span="2">{{ (paymentMethodOptions.find(item => item.value === info.quotePaymentMethod) || {}).label || '--' }}</el-descriptions-item>
          <el-descriptions-item label="发票类型" :span="2">{{ (InvoiceTypeEnum.find(item => item.value === info.quoteInvoiceType) || {}).label || '--'}}</el-descriptions-item>
        </el-descriptions>
      </template>
      <template v-else>
        <el-form :model="form" ref="JZForm" :rules="rules" size="mini" label-position="right" label-width="100px">
          <el-form-item label="询单接单人" prop="inquirePriceTaskOrderUserId">
            <el-radio v-model="radio" :label="true">固定员工</el-radio>
            <el-select v-model="form.inquirePriceTaskOrderUserId" placeholder="请选择" clearable style="width: 300px;">
              <el-option v-for="item in employeeList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="税率" prop="quoteTaxRate">
            <el-select v-model="form.quoteTaxRate" placeholder="请选择" clearable style="width: 300px;">
              <el-option v-for="opt in taxRateOptions" :key="opt.optionCode" :label="opt.optionName"
                :value="opt.optionName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款方式" prop="quotePaymentMethod">
            <el-radio-group v-model="form.quotePaymentMethod">
              <el-radio v-for="opt in paymentMethodOptions" :key="opt.value" :label="opt.value">{{ opt.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="发票类型" prop="quoteInvoiceType">
            <el-radio-group v-model="form.quoteInvoiceType">
              <el-radio v-for="opt in InvoiceTypeEnum" :key="opt.value" :label="opt.value">{{ opt.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </template>
    </div>
  </div>
</template>
<script>
import { InvoiceTypeEnum } from '@/enums/InvoiceTypeEnum';
import UserApi from '@/api/user';
import { getTenantSellerSettingDetail, saveInquirePriceTaskOrderUser, setTenantSellerSettingDetail } from '@/api/shop';
import { dictionaryData } from '@/api/inquiryForm.js';

export default {
  props: {
    baseInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      isEdit: false,
      radio: true,
      admin: {},
      info: {},
      form: {
        inquirePriceTaskOrderUserId: null,
        quoteInvoiceType: null,
        quotePaymentMethod: null,
        quoteTaxRate: null,
      },
      rules: {
        inquirePriceTaskOrderUserId: [
          { required: true, message: '请设置询单接单人' },
        ],
        quoteInvoiceType: [
          { required: true, message: '请设置发票类型' },
        ],
        quotePaymentMethod: [
          { required: true, message: '请设置付款方式' },
        ],
        quoteTaxRate: [
          { required: true, message: '请设置税率' },
        ],
      },
      employeeList: [],
      taxRateOptions: [],
      paymentMethodOptions: [
        {
          label: '货到付款',
          value: 1,
        },
        {
          label: '预付款',
          value: 2,
        },
        {
          label: '票到付款',
          value: 3,
        },
        {
          label: '账期付款',
          value: 4,
        },
      ],
      InvoiceTypeEnum,
    };
  },
  watch: {
    isEdit (v) {
      if (v) {
        this.queryEmployeeList();
        this.getTaxRateDictionaryData();
        this.form = {
          inquirePriceTaskOrderUserId: this.info.inquirePriceTaskOrderUserId || null,
          quoteInvoiceType: this.info.quoteInvoiceType || null,
          quotePaymentMethod: this.info.quotePaymentMethod || null,
          quoteTaxRate: this.info.quoteTaxRate !== null && this.info.quoteTaxRate !== undefined ? `${this.info.quoteTaxRate}%` : null,
        };
      }
    },
  },
  methods: {
    async queryEmployeeList () {
      const { body } = await UserApi.getUserList({
        orderBy: [{
          orderByProperty: 'createTime',
          orderByType: 'ASC',
        }],
        pageFlag: false,
      });
      this.employeeList = body.list || [];
      if (this.admin.account) {
        this.form.inquirePriceTaskOrderUserId = (this.employeeList.find(item => item.phoneNumber === this.admin.account) || {}).id;
      }
    },
    async getTaxRateDictionaryData () {
      const { body } = await dictionaryData({
        enableFlag: 1,
        typeCode: 'TAX_RATE',
      });
      this.taxRateOptions = body || [];
    },
    handleEdit () {
      this.isEdit = !this.isEdit;
    },
    handleClose () {
      this.handleEdit();
    },
    handleSave () {
      this.$refs.JZForm.validate().then(async valid =>{
        if (valid) {
          await saveInquirePriceTaskOrderUser({inquirePriceTaskOrderUserId: this.form.inquirePriceTaskOrderUserId});
          await setTenantSellerSettingDetail({
            quoteInvoiceType: this.form.quoteInvoiceType,
            quotePaymentMethod: this.form.quotePaymentMethod,
            quoteTaxRate: this.form.quoteTaxRate.replace('%', '') * 1,
          });
          this.$message.success('保存成功');
          this.isEdit = false;
          this.init();
        }
      });
    },
    async init () {
      let { body } = await getTenantSellerSettingDetail({});
      if (!body.inquirePriceTaskOrderUserId) {
        this.admin = (this.baseInfo.employeeRespDTO || []).find(item => item.account === this.baseInfo.adminAccount) || {};
        body.inquirePriceTaskOrderUserName = this.admin.name;
      }
      this.info = body;
    },
  },
  created () {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.quote-price-setting {
  font-size: 14px;
  color: #1F2733;

  .flex-item {
    display: inline-flex;
    align-items: center;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eeeeee;

    .tip {
      font-weight: 400;
      font-size: 12px;
      color: #929AA6;
      margin: 0 15px;
    }
  }

  .content {
    padding: 20px;
    /deep/ .el-descriptions-item__label {
      color: #929AA6;
    }

    /deep/ input[aria-hidden="true"] {
      display: none !important;
    }

    /deep/.el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
      box-shadow: none !important;
    }

    .employee-type {
      background: #E2F3FE;
      border-radius: 4px;
      margin: 0 15px;
      padding: 0 6px;
      font-weight: 400;
      font-size: 12px;
      color: #237FFA;
    }
  }
}
</style>
